export enum CancelPolicy {
	NEVER_CANCEL,
	NO_DUPLICATE_PATH,
}
